module.exports = __webpack_public_path__ + "img/lang_logos.228aa33c.png";